import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services/http/auth/auth.service';
import { UtilService } from '../shared/services/util/util.service';
import { ClientService } from '../shared/services/client.service';

@Injectable({
  providedIn: 'root'
})
export class ClientGuard implements CanActivate {

  constructor(
    private clientService: ClientService,
    private authService: AuthService,
    private router: Router,
    private utilService: UtilService
  ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Get client from URL params
    const urlClient = route.paramMap.get('client');

    // Check if user is logged in
    const isLoggedIn = !!this.authService.getToken();

    if (!isLoggedIn) {
      // If not logged in, just validate that the client is valid
      if (urlClient && this.clientService.getClientConfig(urlClient)) {
        return true;
      }
      // Invalid client in URL
      // this.utilService.showErrorDialog({
      //   msg: 'Invalid client identifier in URL'
      // });
      this.router.navigate(['/']);
      return false;
    }

    // User is logged in - validate client matches
    const storedClient = this.clientService.getCurrentClient();

    if (!storedClient) {
      // User is logged in but no client stored - this shouldn't happen
      // Log them out for safety
      // this.utilService.showErrorDialog({
      //   msg: 'Session error. Please login again.'
      // });
      this.logout();
      return false;
    }
    // Check if the client in the URL matches the stored client
    if (urlClient !== storedClient) {
      // Client mismatch - log user out
      // this.utilService.showErrorDialog({
      //   msg: 'You are not authorized to access this client. You have been logged out.'
      // });
      this.logout();
      return false;
    }

    return true;
  }

  private logout(): void {
    localStorage.clear();
    this.clientService.clearClient();
    this.router.navigate(['/']);
  }

}
